import AscMxRecContainer from './containers/AscMxRecContainer'
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'

const issueInvestigationRouter = {
  icon: 'mdi-file',
  path: '/maintenance/issueid/:issueId',
  name: 'Mx Recs',
  component: AscMxRecContainer,
  display: false,
  meta: {
    requiresResourcePermission: {
      resource: RESOURCES.MAINTENANCE_REC,
      permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
    },
    requiresEccn: false,
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Maintenance Issues',
      },
      {
        text: route => ` ${route.params.issueId}`,
      },
    ],
  },
  props: route => ({
    issueId: Number(route.params.issueId),
  }),
  beforeEnter: (to, from, next) => {
    if (isNaN(to.params.issueId) || Number(to.params.issueId) === 0) {
      next('/404')
    } else {
      next()
    }
  },
  children: [],
}

export default issueInvestigationRouter
